import React from 'react';

import { SidePage } from '@gogame/components';

import { LEFT_DRAWER_Z_INDEX } from '../Sidebar/constants';
import SubscriptionsList from './SubscriptionsList';
import { useIsUpdating, useLoadSubscriptions } from './data';

export const SubscriptionsSidePage = ({ open, onClose, onExited }) => {
  const { isLoading, data, isRefetching } = useLoadSubscriptions();
  const isUpdating = useIsUpdating();
  return (
    <SidePage
      open={open}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading || isUpdating}
      fetching={isRefetching}
      backdrop={false}
      size={'m'}
      direction={'right'}
      directionOfset={'64px'}
      zIndex={LEFT_DRAWER_Z_INDEX}
    >
      <SidePage.Title onClose={onClose} title={'Subscriptions'} />
      <SidePage.Content disableGutters={true} disableScroll={true}>
        <SubscriptionsList data={data} />
      </SidePage.Content>
    </SidePage>
  );
};
